import { cn } from "@/utils/cn";

function Skeleton({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      className={cn("animate-pulse rounded-xs bg-utility-gray-200", className)}
      data-slot="skeleton"
      {...props}
    />
  );
}

export { Skeleton };
